module.exports = __webpack_public_path__ + "media/testimonials/3-9a022653.jpg";